export const KEYCLOAK_ADMIN_ROLE = "admin";